import * as React from 'react';
import { cn } from '@/lib/utils';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'box-border flex h-10 w-full min-w-0 max-w-full rounded-[var(--inv-radius-control,12px)] border border-solid border-[var(--inv-border)] bg-[var(--inv-surface)] px-3 py-2 text-sm text-[var(--inv-text)] shadow-[var(--inv-shadow)] placeholder:text-[var(--inv-text-muted)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--inv-accent-ring)] disabled:cursor-not-allowed disabled:bg-[#f7f7f7] disabled:text-[#5a5a5a] disabled:opacity-60',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };

